import { apiRequest } from './client';
import type { Bbox } from './cells';

export interface CityWithBoundary {
  city_id: string;
  name: string;
  region: string | null;
  country_code: string;
  total_cells: number;
  geometry: GeoJSON.Polygon | GeoJSON.MultiPolygon;
}

export async function fetchCitiesInBbox(bbox: Bbox): Promise<CityWithBoundary[]> {
  const qs = new URLSearchParams({
    min_lat: bbox.min_lat.toString(),
    min_lng: bbox.min_lng.toString(),
    max_lat: bbox.max_lat.toString(),
    max_lng: bbox.max_lng.toString(),
  });
  const data = await apiRequest<{ cities: CityWithBoundary[] }>(
    `/cities/in-bbox?${qs.toString()}`,
  );
  return data.cities;
}

export interface ContainingCity {
  city_id: string;
  name: string;
  region: string | null;
  country_code: string;
  bbox_min_lat: number;
  bbox_min_lng: number;
  bbox_max_lat: number;
  bbox_max_lng: number;
}

export async function fetchContainingCity(
  lat: number,
  lng: number,
): Promise<ContainingCity | null> {
  const qs = new URLSearchParams({ lat: lat.toString(), lng: lng.toString() });
  const data = await apiRequest<{ city: ContainingCity | null }>(
    `/cities/containing?${qs.toString()}`,
  );
  return data.city;
}

export interface NearestCity extends ContainingCity {
  distance_km: number;
}

export async function fetchNearestCity(
  lat: number,
  lng: number,
  radiusKm = 200,
): Promise<NearestCity | null> {
  const qs = new URLSearchParams({
    lat: lat.toString(),
    lng: lng.toString(),
    radius_km: radiusKm.toString(),
  });
  const data = await apiRequest<{ cities: NearestCity[] }>(`/cities/nearby?${qs.toString()}`);
  return data.cities[0] ?? null;
}
